export default function openMenuDrawerReducer(
   state = { open: false },
   { type }
) {
   switch (type) {
      case 'OPEN_MENU_DRAWER':
         return {
            open: true
         }
      case 'CLOSE_MENU_DRAWER':
         return {
            open: false
         }
      default:
         return state
   }
}
